export default __webpack_public_path__ + "static/media/logo512.73c3aca7.png";